import { render } from "./WishlistComponent.vue?vue&type=template&id=772f8f70"
import script from "./WishlistComponent.vue?vue&type=script&lang=js"
export * from "./WishlistComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/wishlist/WishlistComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "772f8f70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('772f8f70', __exports__)) {
    api.reload('772f8f70', __exports__)
  }
  
  module.hot.accept("./WishlistComponent.vue?vue&type=template&id=772f8f70", () => {
    api.rerender('772f8f70', render)
  })

}


export default __exports__